import { SERVER_URL } from '../../../utils/apiUtilsConstants';

export const fetchProviders = async () => {
  try {
    const response = await fetch(`${SERVER_URL}/api/ui/bo/llm/providers`, {
      method: 'GET',
      credentials: 'include',
    });
    
    if (response.ok) {
      const data = await response.json();
      return data.providers || [];
    }
    
    console.warn('Failed to fetch LLM providers');
    return [];
  } catch (err) {
    console.error('Error fetching LLM providers:', err);
    return [];
  }
};

export const fetchModels = async (type = 'text') => {
  try {
    const response = await fetch(
      `${SERVER_URL}/api/ui/bo/llm/models?type=${type}`,
      {
        method: 'GET',
        credentials: 'include',
      }
    );
    
    if (response.ok) {
      const data = await response.json();
      return data.models || [];
    }
    
    console.warn('Failed to fetch LLM models');
    return [];
  } catch (err) {
    console.error('Error fetching LLM models:', err);
    return [];
  }
};

export const fetchConfigByCategory = async (category, name) => {
  if (!category || !name) {
    return null;
  }
  
  try {
    const response = await fetch(
      `${SERVER_URL}/api/ui/bo/llm/prompts/config/lookup?category=${encodeURIComponent(category)}&name=${encodeURIComponent(name)}`,
      {
        method: 'GET',
        credentials: 'include',
      }
    );
    
    if (response.ok) {
      const data = await response.json();
      return data || null;
    }
    
    return null;
  } catch (err) {
    console.error('Error loading saved LLM config:', err);
    return null;
  }
};

export const fetchConfigByPromptId = async (promptId) => {
  if (!promptId) return null;
  try {
    const response = await fetch(
      `${SERVER_URL}/api/ui/bo/llm/prompts/${encodeURIComponent(promptId)}/config`,
      {
        method: 'GET',
        credentials: 'include',
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data || null;
    }
    return null;
  } catch (err) {
    console.error('Error loading prompt config:', err);
    return null;
  }
};

/**
 * Get the default model from a list of models
 * Prefers models with 'gpt-4o' in the ID, otherwise returns the first model
 */
const getDefaultModel = (models) => {
  if (!models || models.length === 0) {
    return null;
  }
  
  const gpt4oModel = models.find(m => m.id.includes('gpt-4o'));
  return gpt4oModel || models[0];
};

export const applyConfig = ({
  config,
  providers,
  models,
  setSelectedProvider,
  setSelectedModel,
  setLlmTemperature,
  setLlmMaxTokens,
  setFallbackProvider,
  setFallbackModel,
}) => {
  const defaultModel = getDefaultModel(models);

  if (config) {
    const savedConfig = config.config || config;
    setSelectedProvider(savedConfig.provider || (providers.length > 0 ? providers[0].id : ''));
    setSelectedModel(savedConfig.model || (defaultModel?.id || ''));

    if (savedConfig.temperature != null) {
      setLlmTemperature(savedConfig.temperature);
    }

    if (savedConfig.maxTokens != null) {
      setLlmMaxTokens(savedConfig.maxTokens);
    }

    if (setFallbackProvider) {
      setFallbackProvider(savedConfig.fallbackProvider || '');
    }
    if (setFallbackModel) {
      setFallbackModel(savedConfig.fallbackModel || '');
    }
  } else {
    if (providers.length > 0) {
      setSelectedProvider(providers[0].id);
    }
    if (defaultModel) {
      setSelectedModel(defaultModel.id);
    }
    if (setFallbackProvider) setFallbackProvider('');
    if (setFallbackModel) setFallbackModel('');
  }
};
